<template>
  <div>
    <div>
      <div class="departure-area">
        <div class="input-box">
          <InputBox text="出発地を設定" v-model="inputDeparture" :autocomplete=coockieDepList />
        </div>
        <div class="current-spot">
          <TextLinkInline text="現在地" @click-text="onClickGeo" />
        </div>
      </div>
      <div class="input-box">
        <InputBox text="目的地を設定" v-model="inputDestionation" :autocomplete=coockieDesList />
      </div>
    </div>
    <span class="title-text">出発時刻</span>
    <input class="input-time" v-model="inputTime" type="time" id="appt" name="appt" required>
    <TextLinkInline text="現在時刻" @click-text="onClickNow" />
    <TextLink
      class="search-button"
      text="検索する"
      :disable=!inputCheck
      @click-text="onClickSearch"
    />
    <TextLink
      class="search-button"
      text="周辺スポットを検索する"
      @click-text="onClickNearBySearch"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import TextLink from '@/components/Atoms/TextLink'
import TextLinkInline from '@/components/Atoms/TextLinkInline'
import InputBox from '@/components/Atoms/InputBox'

export default {
  name: 'route-search-inputs',
  components: {
    TextLink,
    TextLinkInline,
    InputBox
  },
  computed: {
    ...mapState(['currentLat', 'currentLng']),
    inputCheck () {
      return !!(this.inputTime !== '' && this.inputDeparture !== '' && this.inputDestionation !== '')
    },
    coockieDepList () {
      return JSON.parse(this.$cookies.get('departurelist'))
    },
    coockieDesList () {
      return JSON.parse(this.$cookies.get('destionationlist'))
    }
  },
  data () {
    return {
      inputTime: '',
      inputDeparture: '',
      inputDestionation: ''
    }
  },
  mounted () {
    this.onClickNow()
  },
  methods: {
    ...mapMutations([
      'loadingStartMini',
      'loadingEndMini',
      'changeCurrentLatLng'
    ]),
    onClickGeo () {
      this.loadingStartMini()
      let changeCurrentLatLng = this.changeCurrentLatLng
      let loadingEndMini = this.loadingEndMini
      navigator.geolocation.getCurrentPosition(function (position) {
        changeCurrentLatLng({
          lat: position.coords.latitude,
          lng: position.coords.longitude
        })
        loadingEndMini()
      },
      function (err) {
        var msgs = [
          err.message,
          '位置情報の取得を許可されていません。',
          '位置情報の取得に失敗しました。',
          '位置情報を取得中にタイムアウトしました。'
        ]
        window.alert(msgs[err.code])
      },
      { maximumAge: 0 })
      this.inputDeparture = '現在地'
    },
    onClickNow () {
      var date = new Date()
      let h = this.zeroPaddingAndStr(date.getHours())
      let m = this.zeroPaddingAndStr(date.getMinutes())
      this.inputTime = h + ':' + m
    },
    zeroPaddingAndStr (num) {
      if (num < 10) {
        return '0' + String(num)
      }
      return String(num)
    },
    changeDeparture (e) {
      this.inputDeparture = e
    },
    onClickSearch () {
      this.$emit('click-button', {
        'departure': this.inputDeparture,
        'destination': this.inputDestionation,
        'departureTime': this.inputTime
      })
    },
    onClickNearBySearch () {
      this.$emit('click-button', {
        'departure': '現在地',
        'destination': '現在地',
        'departureTime': this.inputTime
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './../../unified.scss';
.input-box {
  width: calc(100% - 3.5rem);
}
.current-spot {
  vertical-align: middle;
}

.departure-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.input-time{
  margin: 0.5rem;
  font-size:16px;
}
.title-text{
  font-weight: bold;
}
.search-button{
  font-size: 1.5rem;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Organisms/RouteSearchInputs.vue